import HomeSlider from "../Home/HomeSlider";
import HomeContent from "../Home/HomeContent";
import About from "../Home/About";

const Home = () => {
    return(
        <>
            <HomeContent />
            <About />
        </>
    )
}

export default Home;